import React from 'react'
import './CallToAction.css'

function CallToAction() {
    return (
        <section id="cta" className="cta">
        <div className="container" data-aos="zoom-in">

            <div className="text-center">
            <h3>Call To Action</h3>
            <p> Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <a className="cta-btn" href="/#">Call To Action</a>
            </div>

        </div>
        </section>
    )
}

export default CallToAction
